import { ContextMenu } from '@ohif/ui';

export default {
  'ui.contextMenu': ContextMenu,
};
